import UserSettingReferrals from './user-settings-referrals';

export default UserSettingReferrals;
